'use strict';

/**
 * nav
 */
export const nav = (() => {
    const $toggle = $('.js-toggle-nav');
    const $hide = $('.js-hide-nav');
    const $menu = $('.js-menu');
    const $toTop = $('.js-pagetop');
    let $topHeight = 0;
    let $wHeight = 0;
    let $wWidth = 0;
    let cr_pos = 0;
    let pageHeight = 0;
    let stop_pos = 0;

    $(window).on('load resize', function () {
        $wHeight = $(window).outerHeight();
        $wWidth = $(window).outerWidth();
        $topHeight = $('.js-top-h').innerHeight();
    });

    const toggle = () => {
        $('body').toggleClass('is-show-nav');
    };

    const hide = () => {
        $('body').removeClass('is-show-nav');
    };


    const init = () => {
        $toggle.on('click', event => {
            toggle();
        });

        $hide.on('click', event => {
            hide();
        });
    };

    return {
        init: init
    };
})();
